import React from 'react';

import {  faHome } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Card, Form, Button,Breadcrumb } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Routes } from '../../routes.js';

export default () => {
  
  return (
    <>
    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mt-4">
    <div className="d-block mb-4 mb-md-0">
      <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
        <Breadcrumb.Item><Link to={"/dashboard/overview"}><FontAwesomeIcon icon={faHome} /></Link></Breadcrumb.Item>
       
        <Breadcrumb.Item active>Bulk Message</Breadcrumb.Item>
      </Breadcrumb>
      <h4>Bulk Message</h4>
    </div>
    
  </div>
    <Card border="light" className="bg-white mb-4 ">
      
    <Card.Body>
    
      <Form>
        <Row>
        <Col md={9} >
        <Row>
        <Col md={12} className="mb-3">
        <Form.Group id="Name">
              <Form.Label> Application Status</Form.Label>
           
            </Form.Group>
            <Row>
            <Col md={4} className="mb-3">
            <Form.Check label="Application Approved" id="Approved" htmlFor="Approved" />
            
            </Col> 
            <Col md={4} className="mb-3">
            <Form.Check label="Application Declined" id="Declined" htmlFor="Declined" />
            
            </Col>
            <Col md={4} className="mb-3">
            <Form.Check label="Application Suspended" id="Suspended" htmlFor="Suspended" />
            
            </Col>
            <Col md={4} className="mb-3">
            <Form.Check label="Incomplete Application" id="Incomplete" htmlFor="Incomplete" />
            
            </Col>
            <Col md={4} className="mb-3">
            <Form.Check label="Waiting For Merchant" id="Merchant" htmlFor="Merchant" />
            
            </Col>
            <Col md={4} className="mb-3">
            <Form.Check label="Waiting For Bank" id="Bank" htmlFor="Bank" />
            
            </Col>
            <Col md={4} className="mb-3">
            <Form.Check label="Waiting For Agent" id="Agent" htmlFor="Agent" />
            
            </Col>
            <Col md={4} className="mb-3">
            <Form.Check label="Application Applied" id="Applied" htmlFor="Applied" />
            
            </Col>
            </Row>
        </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="Name">
              <Form.Label> Application ID / User</Form.Label>
              <Form.Control required type="text" placeholder="Enter application ID / user" />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
          <Form.Group>
    <Form.Label>Message</Form.Label>
    <Form.Control as="textarea" rows="4" placeholder="Enter your message..." />
  </Form.Group>
          </Col>
        </Row>
        <hr/>
        <div className="mt-3">
          <Button as={Link} to={Routes.Userlists.path} variant="primary" type="submit">Update Status</Button>
        </div>
        </Col>  
        <Col md={3} >
        <h4>Legend</h4>
        <hr />
        <Form.Group id="Name">
              <Form.Label> Application Status</Form.Label>
           
            </Form.Group>
            <Form.Group id="Name">
              <Form.Label> Customer Name</Form.Label>
           
            </Form.Group>
            <Form.Group id="Name">
              <Form.Label> Customer Email</Form.Label>
           
            </Form.Group>
        </Col>  
        
        
       
        </Row>
       
      
      </Form>
    </Card.Body>
  </Card>
  </>
  );
};
